import Swal from "sweetalert2";

for (const entry of document.querySelectorAll(".confirm-post")) {
	entry.addEventListener("click", async (evt) => {
		evt.preventDefault();

		const result = await confirmation(entry);

		if (result.value) {
			await window.fetch(entry.href, {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: `token=${entry.dataset.token}`,
			});

			location.reload();
		}
	});
}

for (const entry of document.querySelectorAll(".confirm-link")) {
	entry.addEventListener("click", async (evt) => {
		evt.preventDefault();

		const result = await confirmation(entry);

		if (result.value) {
			location.href = entry.href;
		}
	});
}

for (const entry of document.querySelectorAll(".confirm-submit")) {
	entry.addEventListener("submit", async (evt) => {
		evt.preventDefault();

		const result = await confirmation(entry);

		if (result.value) {
			entry.submit();
		}
	});
}

async function confirmation(entry) {
	const msg = entry.dataset.confirmMsg || "Sind Sie sicher?";

	return await Swal.fire({
		title: "Bestätigung",
		text: msg,
		showCancelButton: true,
		cancelButtonText: "Nein, abbrechen.",
		confirmButtonText: "Ja, fortfahren.",
	});
}
